<template>
	<div>
		<div class="cm_bottom">
			<div class="owidth clearfix">
				<!-- <a href="" class="cm_btm_lgo"><img src="@/assets/logo.png" /></a> -->
				<a href="" class="cm_btm_lgo"> <img src="@/assets/home/home_logo.png" alt="" /></a>
			</div>
		</div>
		<div class="cm_bottom cm_btm_con clearfix">
			<hr />
			<div class="owidth clearfix">
				<div class="cm_bottom_qrcode">
					<img src="@/assets/qrcode.jpg" />
					<!-- <img :src="showUrl + QRcode" /> -->
					<!-- <span>扫一扫<br />
						关注我们</span> -->
				</div>
				<div class="cm_bottom_left">
					<div class="cm_bottom_left_one ">
						<div class="cm_bottom_left_item">
							<p class="cm_bottom_large">业务咨询<span>(周一到周五 8:30-17:30)</span></p>
							<p class="cm_bottom_small">{{ consultPhone }}</p>
						</div>
						<div class="cm_bottom_left_item">
							<p class="cm_bottom_large">
								<!-- <img src="@/assets/ico_cloud.png" /> -->
								传真
							</p>
							<p class="cm_bottom_small">
								{{ fax }}
							</p>
						</div>
					</div>
					<div class="cm_bottom_left_two">
						<p class="cm_bottom_large">
							<!-- <img src="@/assets/home_address.png" /> -->
							地址
						</p>
						<p class="cm_bottom_small">
							{{ address }}
						</p>
					</div>
					<!-- <p class="cm_bottom_large">咨询热线</p>
					<p class="cm_bottom_large">{{consultPhone}}</p>
					<hr />
					<p class="cm_bottom_large">
						<img src="@/assets/foreground/img/ico_cloud.png" />服务邮箱
					</p>
					<p class="cm_bottom_large">{{email}}</p> -->
				</div>
				<div class="cm_bottom_middle">
					<p class="cm_bottom_large">快速入口</p>
					<div class="middle_item">
						<div class="middle_flex_two">
							<p v-for="item in quickLinkList" :key="item.linkId"><a
									:href="item.linkUrl">{{ item.linkName }}</a></p>
						</div>
					</div>
					<!-- <p v-for="item in quickLinkList" :key="item.linkId"><a :href="item.linkUrl">{{item.linkName}}</a></p> -->
					<!-- <p><a href="">工具</a></p> -->
				</div>
			</div>
			<div class="btn clearfix">
				<div class="friend">友情链接</div>
				<div class="linkUrl">
					<div v-for="item in friendLinkList" :key="item.linkId"><a :href="item.linkUrl">{{ item.linkName }}</a>
					</div>
				</div>
			</div>
		</div>
		<div class="cm_bottom cm_bottom_cpy">
			<hr />
			{{ Copyright[1] }} {{ Copyright[2] }}<br />
			{{ Copyright[0] }}&nbsp;{{ version }}<br />
			<a class="beian" :href="Copyright[4]">{{ Copyright[3] }}</a>
		</div>
	</div>
</template>

<script>
import { showUrl, getAppVersion,getSysWebsite } from '@/api/api'
export default {
	name: 'App',
	components: {},
	data() {
		return {
			Copyright: [],
			version: '',
			logoImg: '',
			QRcode: '',
			consultPhone: '',
			email: '',
			address: '',
			fax: '',
			quickLinkList: [],
			friendLinkList: [
			// 	{
			// 	linkId:1,
			// 	linkUrl:'https://www.weilongshipin.com/',
			// 	linkName:'卫龙平台'
			// },{
			// 	linkId:2,
			// 	linkUrl:'http://www.hndzy.com/index.html',
			// 	linkName:'河南电子规划研究院'
			// }
		],
			showUrl,
		}
	},
	created() {
		this.getBasicSetData()
		this.getAppVersion()
	},
	methods: {
		// 获取版本号
		getAppVersion() {
			let data = {
				appId: window.name
			}
			getAppVersion(data).then(res => {
				this.version = res
			})
		},
		// 获取网站信息
		getBasicSetData() {
			getSysWebsite().then(res => {
				var setData=res.data
			
			// if (localStorage.getItem('basicSet')) {
			// 	console.log(123);
			// 	let setData = JSON.parse(localStorage.getItem('basicSet'))
				// 底部logo
				this.logoImg = setData.openFooterLogo
				// 版权信息
				this.Copyright = setData.copyrightInfo.split('|')
				// 版本号
				// this.version=setData.version
				// 二维码
				// this.QRcode = setData.qrCodePath
				// 咨询热线
				this.consultPhone = setData.phone
				// 邮箱
				this.email = setData.email
				// 传真
				this.fax = setData.fax
				// 地址
				this.address = setData.address
				// 快速链接
				this.quickLinkList = setData.quickLinkList
				// 友情链接
				this.friendLinkList = setData.friendLinkList
			})
		}
		// },
	},
	watch: {

	}
}
</script>

<style lang="less" scoped>
/*通用格式 start */
.cm_bottom {
	background-color: #f5f5f5;
	padding: 10px 0;
	color: #222222;

	.cm_btm_lgo {
		float: left;
		padding: 8px 0;

		img {
			display: block;
		}
	}

	&.cm_btm_con {
		padding-top: 0;
	}
}

.cm_bottom_middle,
.cm_bottom_right {
	float: left;
	width: 300px;
	// border-right: 1px #e5e5e5 solid;
	// padding: 20px 0;
}

.cm_bottom hr {
	border: none;
	height: 1px;
	background-color: #e5e5e5;
}

.cm_bottom p {
	padding: 16px 0;
	font-size: 12px;
}

.cm_bottom_left hr {
	margin: 16px 0;
}

.cm_bottom_left img {
	margin-right: 8px;
}

.cm_bottom_middle {
	padding-left: 110px;
}

.cm_bottom a {
	color: #666;
	font-size: 14px;
}

.cm_bottom a:hover {
	color: #222222;
}

.cm_bottom .cm_bottom_large {
	font-size: 16px;
	color: #222;
	span{
		font-size: 14px;
	}
}

.cm_bottom_right {
	border-right: none;
	margin-left: 100px;
}

.cm_bottom_qrcode {
	float: right;
	padding: 20px 0;
	text-align: center;
}

.cm_bottom_qrcode span {
	font-size: 14px;
	line-height: 20px;
	color: #c1c2c2;
}

.cm_bottom_qrcode img {
	display: block;
	// border: 3px #222222 solid;
	width: 100px;
	height: 100px;
	margin-bottom: 10px;
}

.cm_bottom_left,
.cm_bottom_middle,
.cm_bottom_right {
	height: 300px;
}

.cm_bottom_cpy {
	font-size: 12px;
	color: #999;
	margin-top: -20px;
	text-align: center;
	line-height: 25px;
	padding-bottom: 20px;
	.beian{
		color: #999 !important;
		font-size: 12px !important;
	}
}

.cm_bottom_cpy hr {
	margin-bottom: 20px;
}

/*通用格式 end */
.cm_bottom_left {
	float: left;
	width: 600px;
	border-right: 1px #e5e5e5 solid;
}

.cm_bottom_left_one {
	display: flex;
	align-items: center;
	border-bottom: 1px #e5e5e5 solid;

	.cm_bottom_left_item {
		// height: calc((100% - 2px) / 3);
		// height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 49%;

		&:nth-child(1) {
			padding: 35px 0 45px 0;
			border-right: 1px #e5e5e5 solid;
		}

		&:nth-child(2n) {
			padding: 35px 0 45px 54px;
		}

		p {
			padding: 0px;
		}

		.cm_bottom_large {
			font-size: 16px;
			margin-bottom: 20px;
		}

		.cm_bottom_small {
			font-size: 14px;
		}
	}
}

.btn {
	display: flex;
	width: 1221px;
	margin: 0 auto;
	border-top: 1px #e5e5e5 solid;
	padding: 27px 0;

	.friend {
		font-size: 16px;
		line-height: 22px;
		color: #222222;
		width: 130px;
	}

	.linkUrl {
		display: flex;
		padding-top: 3px;
		flex-wrap: wrap;
		color: #bbbbbd;
		font-size: 14px;
		width: 100%;

		div {
			width: 18%;
			margin-right: 40px;
			padding-bottom: 20px;
		}
	}
}

.middle_item {
	width: 100%;

	p {
		line-height: 21px;
	}

	.middle_flex {
		width: 33%;
	}

	.middle_flex_two {
		display: flex;
		width: 340px;

		p {
			width: 112px;
		}
	}

	// p:nth-child(even) {
	//     width: 40%;
	// }

	// p:nth-child(odd) {
	//     width: 60%;
	// }
}

.cm_bottom_middle {
	padding: 34px 73px;

	.cm_bottom_large {
		padding: 0;
		margin-bottom: 16px;
	}

	.middle_item {
		width: 100%;

		p {
			line-height: 21px;
		}

		.middle_flex {
			width: 33%;
		}

		.middle_flex_two {
			display: flex;
			width: 340px;
			flex-wrap: wrap;

			p {
				width: 112px;
			}
		}

		// p:nth-child(even) {
		//     width: 40%;
		// }

		// p:nth-child(odd) {
		//     width: 60%;
		// }
	}
}

.cm_bottom_left_two {
	padding: 35px 0 45px 0px;

	p {
		padding: 0px !important;
	}

	.cm_bottom_large {
		font-size: 16px;
		margin-bottom: 20px;
	}

	.cm_bottom_small {
		font-size: 14px;
	}
}</style>
